import { useTranslation } from '../../../i18n';
import { EmployeeAvatar } from '../../Shared/EmployeeAvatar';
import { StatusDot } from '../StatusDot';
import type { TodayStatus } from '../../../types/dashboard';

interface Props {
  row: TodayStatus;
}

export function TodayStatusRow({ row }: Props) {
  const { t } = useTranslation('dashboard');
  const statusLabel = t(`admin.status.${row.status}`);
  return (
    <div className="flex items-center gap-3 py-2.5 px-3 rounded-lg hover:bg-surface-muted dark:hover:bg-slate-800/60 transition-colors">
      <EmployeeAvatar
        employee={{
          firstName: row.employee.firstName,
          lastName: row.employee.lastName,
          avatarColor: row.employee.avatarColor ?? null,
        }}
        size={32}
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-ink dark:text-slate-50 truncate">
            {row.employee.firstName} {row.employee.lastName}
          </span>
        </div>
        <div className="flex items-center gap-1.5 mt-0.5">
          <StatusDot status={row.status} pulse={row.status === 'in'} />
          <span className="text-[11px] text-ink-muted dark:text-slate-400 font-mono-num">
            {statusLabel}
            {row.since && ` · ${t('admin.today.since')} ${row.since}`}
            {row.at && ` · ${t('admin.today.at')} ${row.at}`}
          </span>
        </div>
      </div>
    </div>
  );
}
